<button [type]="getType()" [id]="id" class="button is-block" [ngClass]="getButtonClasses()" [disabled]="isDisabled()">
  <em *ngIf="direction === 'left'" class="left-icon" [ngClass]="getIconClass()"> </em>
  <span [ngClass]="getMarginDirection()"><ng-content *ngIf="!loading; else isLoading"></ng-content></span>
  <ng-template #isLoading>{{ loadingText }}</ng-template>
  <em *ngIf="direction === 'right'" [ngClass]="getIconClass()" class="right-icon"> </em>
</button>
